(() => {
  const syncLabels = () => {
    document.querySelectorAll('variant-selects fieldset[data-option-position]').forEach((fieldset) => {
      const label = fieldset.querySelector('[data-bb-option-value]');
      const selected = fieldset.querySelector('input:checked');
      if (label && selected) label.textContent = selected.value;
    });
  };

  let pending = false;
  const scheduleSync = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      syncLabels();
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-selects')) scheduleSync();
  });
  document.addEventListener('variant-update', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncLabels, { once: true });
  else syncLabels();
})();
